module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.getStore().statsError && (!_vm.isEmptyObject(_vm.getStats()) || _vm.isContractorCo() || _vm.isLandlordCo() || _vm.isBackhaulCo())) ? _c('div', [(this.loggedIn()) ? _c('el-menu', {
    attrs: {
      "router": true,
      "mode": "horizontal",
      "background-color": "#2f3e57",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "home",
      "route": {
        path: this.loggedIn() ? '/' : ''
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('img', {
    staticClass: "nav-logo",
    staticStyle: {
      "height": "2.5em"
    },
    attrs: {
      "src": '../' + _vm.logo,
      "alt": _vm.clientName
    }
  })])], 2), _vm._v(" "), _vm._l((_vm.menu), function(item, index) {
    return [(item.visible) ? _c('el-menu-item', {
      attrs: {
        "index": item.key,
        "route": {
          path: item.path
        }
      }
    }, [_c('i', {
      class: item.icon
    }, [_vm._v(" ")]), _vm._v(_vm._s(_vm.isDesktop ? item.title : '') + "\n      ")]) : _vm._e()]
  }), _vm._v(" "), (this.loggedIn()) ? _c('el-submenu', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "index": "99"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.isDesktop ? this.profile().login : ''))])]), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "7-1",
      "route": {
        path: '/profile'
      }
    }
  }, [_c('i', {}), _vm._v(" User Profile")])], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": ""
    }
  }, [(_vm.isManager()) ? _c('el-menu-item', {
    attrs: {
      "index": "7-2",
      "route": {
        path: '/settings'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Settings")]) : _vm._e()], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "7-3",
      "route": {
        path: '/logout'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" Logout")])], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "About.."
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "7-4",
      "route": {
        path: '/about'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" About")])], 1)], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('el-container', [_c('el-main', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1) : (_vm.getStore().statsError) ? _c('div', [_c('center', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-exclamation-triangle fa-2x text-warning"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Server Side Unknown Error")]), _vm._v(" "), _c('p', [_vm._v("We are sorry but our server encountered an internal error.")]), _vm._v(" "), _c('p', [_vm._v("Please try again later.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("If the issue persists, please contact support.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.refreshBrowser()
      }
    }
  }, [_vm._v("Reload")])], 1)], 1) : _c('div', [_c('center', [_c('i', {
    staticClass: "fa fa-spinner fa-2x fa-spin text-primary"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84630558"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1581
// module chunks = 0